import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { GitLabConfigurationItem } from "./GitLabConfigurationItem"

import type { GitLabIntegration } from "@/api/useIntegrations.types"
import type { GitLabConfigurationTabProps } from "."

export const GitLabConfigurationTab = (props: GitLabConfigurationTabProps) => {
  const keyPrefix = "integrations.connect.gitlab."
  const [data, { t }] = useIntegration(props)
  const installations =
    (data?.configuration?.installations as GitLabIntegration[]) || []
  const noData = !installations.length

  return (
    <>
      {noData && t(`${keyPrefix}noGroup`)}
      {!noData &&
        installations.map(({ groupName: name, groupId, ...rest }) => (
          <GitLabConfigurationItem
            key={groupId}
            keyPrefix={keyPrefix}
            values={{ name, id: `${groupId}`, ...rest }}
            {...props}
          />
        ))}
    </>
  )
}
